var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuoteLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 98,
    viewBox: "0 0 142 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M80 60C80 49.6 81.6 40.6667 84.8 33.2C88 25.4667 92.1333 19.2 97.2 14.4C102.267 9.33334 108 5.73334 114.4 3.6C121.067 1.2 127.6 0 134 0V14C127.067 14 120.533 16.4 114.4 21.2C108.533 25.7333 105.067 32 104 40C104.8 39.7333 105.733 39.4667 106.8 39.2C107.6 38.9333 108.533 38.6667 109.6 38.4C110.933 38.1333 112.4 38 114 38C122 38 128.667 41.0667 134 47.2C139.333 53.0667 142 60 142 68C142 76 139.2 83.0667 133.6 89.2C128.267 95.0667 121.067 98 112 98C101.867 98 94 94.2667 88.4 86.8C82.8 79.0667 80 70.1333 80 60ZM0 60C0 49.6 1.6 40.6667 4.8 33.2C8 25.4667 12.1333 19.2 17.2 14.4C22.2667 9.33334 28 5.73334 34.4 3.6C41.0667 1.2 47.6 0 54 0V14C47.0667 14 40.5333 16.4 34.4 21.2C28.5333 25.7333 25.0667 32 24 40C24.8 39.7333 25.7333 39.4667 26.8 39.2C27.6 38.9333 28.5333 38.6667 29.6 38.4C30.9333 38.1333 32.4 38 34 38C42 38 48.6667 41.0667 54 47.2C59.3333 53.0667 62 60 62 68C62 76 59.2 83.0667 53.6 89.2C48.2667 95.0667 41.0667 98 32 98C21.8667 98 14 94.2667 8.4 86.8C2.8 79.0667 0 70.1333 0 60Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteLeft);
export default __webpack_public_path__ + "static/media/quote-left.77242d25c71bdaec23d5f48ebc075ba6.svg";
export { ForwardRef as ReactComponent };